import React, { CSSProperties, useState } from 'react';
import { ReactComponent as ChevronDownIcon } from '@assets/images/app/chevron-down-nutral90.svg';
import { ReactComponent as ChevronUpIcon } from '@assets/images/app/chevron-up-nutral90.svg';
import { ProductModel } from '@models/product';
import { discountedAmountBy } from '@utils/common';

export const PurchaseBenefits: React.FC<{ data: ProductModel; style?: CSSProperties; collapse?: boolean }> = (
  props,
) => {
  const [showGroupDiscountInfo, setShowGroupDiscountInfo] = useState<boolean>(false);
  const data = props.data;

  const excludeDiscount = (data?.periodDiscountExcludeChannels || []).includes('app') || false;
  if (data?.applyPeriodDiscount && data?.discountInfo?.discountedFee && !excludeDiscount) {
    const today = new Date();
    if (
      data?.discountInfo?.discountStartDate &&
      data?.discountInfo?.discountEndDate &&
      new Date(data?.discountInfo?.discountStartDate) < today &&
      new Date(data?.discountInfo?.discountEndDate) > today
    ) {
      data.fee = data?.discountInfo?.discountedFee || 0;
      data.discount = `${Math.round(100 - (data.fee / data?.originFee) * 100)}%`;
    }
  }

  const expectedFee = discountedAmountBy(data?.fee || 0, 0);
  const purchasePoint = Math.floor(expectedFee * 0.005);
  const photoReviewPoint = Math.floor(expectedFee * 0.03);
  const bestReviewPoint = Math.floor(expectedFee * 0.05);
  const applyGorupDiscount = data?.applyGroupDiscount;

  return (
    <div
      style={{
        borderRadius: '8px',
        border: '1px solid var(--Neutral-30, #E8EAED)',
        background: 'var(--White-100, #FFF)',
        ...props.style,
      }}>
      <div>
        <button
          className="link-button"
          style={{
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}>
          <div
            style={{
              color: 'var(--Neutral-100, #242424)',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
            }}>
            {(purchasePoint + photoReviewPoint).toLocaleString()}원 최대 적립
          </div>
        </button>

        <div style={{ padding: '12px', borderTop: '1px solid #E8EAED' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', height: '20px' }}>
            <div
              style={{
                color: 'var(--Neutral-90, #424242)',
                fontFamily: 'Pretendard',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 500,
                flexShrink: 0,
              }}>
              구매 적립
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', flexGrow: 1 }}>
              <div style={{ width: '100%', height: '50%', borderBottom: '1px dashed #E8EAED' }}></div>
            </div>
            <div
              style={{
                color: 'var(--Primary-95, #FF3D8F)',
                textAlign: 'right',
                fontFamily: 'Pretendard',
                fontSize: '13px',
                fontStyle: 'normal',
                fontWeight: 700,
                flexShrink: 0,
              }}>
              {purchasePoint.toLocaleString()}원
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', height: '20px', marginTop: '8px' }}>
            <div
              style={{
                color: 'var(--Neutral-90, #424242)',
                fontFamily: 'Pretendard',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 500,
                flexShrink: 0,
              }}>
              포토 후기 적립
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', flexGrow: 1 }}>
              <div style={{ width: '100%', height: '50%', borderBottom: '1px dashed #E8EAED' }}></div>
            </div>
            <div
              style={{
                color: 'var(--Primary-95, #FF3D8F)',
                textAlign: 'right',
                fontFamily: 'Pretendard',
                fontSize: '13px',
                fontStyle: 'normal',
                fontWeight: 700,
                flexShrink: 0,
              }}>
              {photoReviewPoint.toLocaleString()}원
            </div>
          </div>
          <div
            style={{
              color: '#FF3D8F',
              textAlign: 'center',
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              height: '40px',
              borderRadius: '4px',
              background: 'var(--Primary-5, #FFF5F9)',
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              marginTop: '12px',
              padding: '10px 12px',
            }}>
            <div
              style={{
                color: '#FF3D8F',
                fontFamily: 'Pretendard',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 500,
                flexShrink: 0,
              }}>
              베스트 후기 선정 시
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', flexGrow: 1 }}>
              <div style={{ width: '100%', height: '50%', borderBottom: '1px dashed #FFC5DD' }}></div>
            </div>
            <div
              style={{
                color: 'var(--Primary-95, #FF3D8F)',
                textAlign: 'right',
                fontFamily: 'Pretendard',
                fontSize: '13px',
                fontStyle: 'normal',
                fontWeight: 700,
                flexShrink: 0,
              }}>
              {bestReviewPoint.toLocaleString()}원 추가 적립 🎉
            </div>
          </div>
        </div>
      </div>
      {applyGorupDiscount && (
        <div style={{ borderTop: '1px solid #E8EAED' }}>
          <button
            className="link-button"
            style={{
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
            onClick={() => {
              setShowGroupDiscountInfo((value) => !value);
            }}>
            <div
              style={{
                color: 'var(--Neutral-100, #242424)',
                fontFamily: 'Pretendard',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 700,
              }}>
              그룹 최대 40% 할인
            </div>
            {showGroupDiscountInfo ? (
              <ChevronUpIcon style={{ width: '16px', height: '16px' }} />
            ) : (
              <ChevronDownIcon style={{ width: '16px', height: '16px' }} />
            )}
          </button>
          {showGroupDiscountInfo && (
            <div style={{ padding: '12px', borderTop: '1px solid #E8EAED' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', height: '20px' }}>
                <div
                  style={{
                    color: 'var(--Neutral-90, #424242)',
                    fontFamily: 'Pretendard',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    flexShrink: 0,
                  }}>
                  2인 그룹 할인
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', flexGrow: 1 }}>
                  <div style={{ width: '100%', height: '50%', borderBottom: '1px dashed #E8EAED' }}></div>
                </div>
                <div
                  style={{
                    color: 'var(--Primary-95, #FF3D8F)',
                    textAlign: 'right',
                    fontFamily: 'Pretendard',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    flexShrink: 0,
                  }}>
                  {`인당 ${(expectedFee * 0.8).toLocaleString()}원`}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', height: '20px', marginTop: '8px' }}>
                <div
                  style={{
                    color: 'var(--Neutral-90, #424242)',
                    fontFamily: 'Pretendard',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    flexShrink: 0,
                  }}>
                  3인 그룹 할인
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', flexGrow: 1 }}>
                  <div style={{ width: '100%', height: '50%', borderBottom: '1px dashed #E8EAED' }}></div>
                </div>
                <div
                  style={{
                    color: 'var(--Primary-95, #FF3D8F)',
                    textAlign: 'right',
                    fontFamily: 'Pretendard',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    flexShrink: 0,
                  }}>
                  {`인당 ${(expectedFee * 0.7).toLocaleString()}원`}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', height: '20px', marginTop: '8px' }}>
                <div
                  style={{
                    color: 'var(--Neutral-90, #424242)',
                    fontFamily: 'Pretendard',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    flexShrink: 0,
                  }}>
                  4인 그룹 할인
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', flexGrow: 1 }}>
                  <div style={{ width: '100%', height: '50%', borderBottom: '1px dashed #E8EAED' }}></div>
                </div>
                <div
                  style={{
                    color: 'var(--Primary-95, #FF3D8F)',
                    textAlign: 'right',
                    fontFamily: 'Pretendard',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    flexShrink: 0,
                  }}>
                  {`인당 ${(expectedFee * 0.6).toLocaleString()}원`}
                </div>
              </div>
              <div
                style={{
                  color: 'var(--Neutral-70, #808387)',
                  textAlign: 'center',
                  fontFamily: 'Pretendard',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  height: '40px',
                  borderRadius: '4px',
                  background: 'var(--Neutral-5, #F8F9FC)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: '12px',
                }}>
                자세한 금액은 상담을 통해 확인해 주세요.
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
